import { useMemo, useState, type Dispatch } from "react";

import ToolBarThreeColumns from "components/Table/ToolBarThreeColumns";

import { debounce } from "utils/debounce";
import { GeneralNames } from "namesConstants/names";

type TableFormPropsT = {
  setSearchTextFilter: Dispatch<React.SetStateAction<Record<string, unknown>>>;
  resetSearchTextFilter: () => void;
  onExportToExcel: () => void;
  onOpenTypeDialog: () => void;
};

const TableForm = ({
  setSearchTextFilter,
  resetSearchTextFilter,
  onExportToExcel,
  onOpenTypeDialog,
}: TableFormPropsT) => {
  const [searchText, setSearchText] = useState("");

  const debouncedUpdate = useMemo(
    () =>
      debounce((value: string) => {
        setSearchTextFilter((prevFilters) => ({
          ...prevFilters,
          global: {
            ...(prevFilters.global as Record<string, unknown>),
            value,
          },
        }));
      }, 500),
    [setSearchTextFilter],
  );

  const onUpdateSearchText = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);
    debouncedUpdate(value);
  };

  const onClearSearchText = () => {
    setSearchText("");
    resetSearchTextFilter();
  };

  const iconsData = [
    { icon: "add", title: GeneralNames.GeneralAdd, onClick: onOpenTypeDialog },
    {
      icon: "excel",
      title: GeneralNames.GeneralExportToExcel,
      onClick: onExportToExcel,
    },
  ];

  return (
    <div
      role="search"
      aria-label="Filtros de tipos de permisos"
      className="flex items-center content-center"
    >
      <ToolBarThreeColumns
        value={searchText}
        clearTextLabel={onClearSearchText}
        onChange={onUpdateSearchText}
        placeholder="Buscar"
        iconsDataPanel={iconsData}
        iNeedDropdown={false}
      />
    </div>
  );
};

export default TableForm;
